import { useEffect } from 'react';
import uuid from 'uuid';
import { BoundedElementsReducerActions, useMap } from './MapContext';

const useBoundedMapElement = (openStreetMapsObj, isBounded) => {
    const {boundedElementsDispatch} = useMap();
    useEffect(() => {
        if (isBounded) {
            const uid = uuid.v1();
            boundedElementsDispatch({type: BoundedElementsReducerActions.ADD_ITEM, uid, coords: openStreetMapsObj.getLatLng()});
            return () => {
                boundedElementsDispatch({type: BoundedElementsReducerActions.REMOVE_ITEM, uid});
            };
        }
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return undefined;
};

export default useBoundedMapElement;



// WEBPACK FOOTER //
// ./src/components/openMap/useBoundedMapElement.js